export const SET_APP_ROUTE = 'SET_APP_ROUTE'
export const SET_NO_PODCASTS = 'SET_NO_PODCASTS'
